import styled from 'styled-components';
import Ico24 from '../Ico24';
import { Typ30 } from '../Typ';

export const Button = styled.button`
  height: 48px;
  width: 288px;
  padding: 10px 20px;
  border-radius: 4px;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  background-color: ${props => (props.color ? props.color : '#004750')};
  box-shadow:
    0 2px 2px rgba(0, 0, 0, 0.24),
    0 0 4px rgba(0, 0, 0, 0.12);
  &:hover {
    filter: brightness(88%);
  }
  &:disabled {
    opacity: 38%;
    box-shadow: none;
    &:hover {
      filter: brightness(100%);
    }
  }
`;

export const Text = styled(Typ30)`
  font-size: 14px;
  line-height: 20px;
  font-weight: normal;
  color: ${props => (props.color ? props.color : '#fff')};
`;

export const Icon = styled(Ico24)`
  color: ${props => (props.color ? props.color : '#fff')};
  padding-right: 12px;
  font-size: 25px;
`;
